@if (formattedDescription) {
  <div [class.multi-line]="isMultiLine">
    @switch (type) {
      @case ('PoolSale') {
        Sold from
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
        for {{ data.price | aacurrency }}
        @if (hasTaxableUse) {
          ({{ data.taxableUse | aapercent }} Taxable Use)
        }
      }
      @case ('PoolWriteOff') {
        Written Off from
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
      }
      @case ('AddToPool') {
        Added to
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
        @if (formattedNotes) {
          <div [innerHTML]="formattedNotes | keepHtml"></div>
        }
      }
      @case ('TransferToPool') {
        Transferred to
        <a [routerLink]="poolRoute(data)">{{ data.poolName }}</a>
        @if (hasTaxableUse) {
          ({{ data.transferredValue || 0 | aacurrency }} -
          {{ data.taxableUse | aapercent }}
          Taxable Use)
        }
        @if (formattedNotes) {
          <div [innerHTML]="formattedNotes | keepHtml"></div>
        }
      }
      @case ('ComponentAdded') {
        Component added:
        <a [routerLink]="assetRoute(data, 'component')">{{
          assetName(data, 'component')
        }}</a>
      }
      @case ('ComponentRemoved') {
        Component removed:
        <a [routerLink]="assetRoute(data, 'component')">{{
          assetName(data, 'component')
        }}</a>
      }
      @case ('ParentAdded') {
        Parent added:
        <a [routerLink]="assetRoute(data, 'parent')">{{
          assetName(data, 'parent')
        }}</a>
      }
      @case ('ParentRemoved') {
        Parent removed:
        <a [routerLink]="assetRoute(data, 'parent')">{{
          assetName(data, 'parent')
        }}</a>
      }
      @case ('AssetGroupAssignedToAsset') {
        Group Assigned:
        <a [routerLink]="assetGroupRoute(data)">{{ assetGroupName(data) }}</a>
      }
      @default {
        <div [innerHTML]="formattedDescription | keepHtml"></div>
      }
    }
  </div>
}

@if (sourceText || importName) {
  <div class="source" [class.multi-line]="isMultiLine">
    {{ sourceText }}
    @if (importName) {
      <a [href]="sourceLink">{{ importName }}</a>
    }
  </div>
}
